import React, { useState } from 'react'

// Material-UI
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import './WhoLivesHereSection.scss'
import { useErrorSnackBarContext } from '../../ErrorSnackBar/ErrorSnackBarContext'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import WhoLivesHereItem from './WhoLivesHereItem'

function WhoLivesHereSection({ residentialplansEntity }) {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  Interceptor.interceptor(errorSnackBarActions)
  const [value, setValue] = useState(0)
  let whoLivesAdults = []
  let whoLivesChildren = []

  if (residentialplansEntity.whoLivesHere && residentialplansEntity.whoLivesHere.length > 0) {
    residentialplansEntity.whoLivesHere.forEach((item) => {
      if (item && item.type !== undefined) {
        if (item.type === 0) {
          whoLivesAdults.push(item)
        } else {
          whoLivesChildren.push(item)
        }
      }
    })
  }

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }

  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <div className="section-content">{children}</div>}
      </div>
    )
  }

  return (
    <div className="App WhoLivesHere">
      <h2>Who lives here?</h2>
      <Container maxWidth="lg">
        <Grid container spacing={1}>
          <Grid size={12}></Grid>
          <Grid size={12}>
            <form noValidate autoComplete="off">
              <Grid container>
                <Grid size={6} sx={{ p: 1 }}>
                  {residentialplansEntity.whoLivesHereIds &&
                  residentialplansEntity.whoLivesHereIds.numberOfAdults ? (
                    <label>
                      How many adults live here?{' '}
                      <b>
                        {residentialplansEntity.whoLivesHereIds
                          ? residentialplansEntity.whoLivesHereIds.numberOfAdults
                          : '0'}
                      </b>
                    </label>
                  ) : null}
                </Grid>
                <Grid size={6} sx={{ p: 1 }}>
                  {residentialplansEntity.whoLivesHereIds &&
                  residentialplansEntity.whoLivesHereIds.numberOfChildren ? (
                    <label>
                      How many children live here?{' '}
                      <b>
                        {residentialplansEntity.whoLivesHereIds
                          ? residentialplansEntity.whoLivesHereIds.numberOfChildren
                          : '0'}
                      </b>
                    </label>
                  ) : null}
                </Grid>
                <Grid size={12}>
                  <br />
                  {residentialplansEntity.whoLivesHere &&
                  residentialplansEntity.whoLivesHere.length > 0 ? (
                    <Grid container size={12}>
                      <AppBar elevation={0} position="sticky" className="header">
                        <Tabs
                          variant="fullWidth"
                          border={0}
                          centered={true}
                          className="detail-tabs-container"
                          value={value}
                          onChange={handleTabChange}
                          aria-label="simple tabs example"
                        >
                          {whoLivesAdults && whoLivesAdults.length > 0 ? (
                            <Tab className="detail-tab" label="Adults" {...a11yProps(0)} />
                          ) : null}
                          {whoLivesChildren && whoLivesChildren.length > 0 ? (
                            <Tab
                              className="detail-tab"
                              label="Children"
                              {...a11yProps(whoLivesAdults.length === 0 ? 0 : 1)}
                            />
                          ) : null}
                        </Tabs>
                      </AppBar>
                      <div className="sticky-container">
                        {whoLivesAdults && whoLivesAdults.length > 0 ? (
                          <TabPanel className="detail-tab section-content" value={value} index={0}>
                            {whoLivesAdults.map((item, index) => {
                              return (
                                <Grid key={item._id} size={12}>
                                  <h3>Adult # {index + 1} </h3> <br />
                                  <WhoLivesHereItem whoLivesHereEntity={item} />
                                </Grid>
                              )
                            })}
                          </TabPanel>
                        ) : null}

                        {whoLivesChildren && whoLivesChildren.length > 0 ? (
                          <TabPanel
                            className="detail-tab section-content"
                            value={value}
                            index={whoLivesAdults.length === 0 ? 0 : 1}
                          >
                            {whoLivesChildren.map((item, index) => {
                              return (
                                <Grid size={12} key={item._id}>
                                  <h3>Child # {index + 1} </h3> <br />
                                  <WhoLivesHereItem key={item._id} whoLivesHereEntity={item} />
                                </Grid>
                              )
                            })}
                          </TabPanel>
                        ) : null}
                      </div>
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default WhoLivesHereSection
